module.exports = __webpack_public_path__ + "static/media/image-card-5.cc2b0229.png";